import { ResponsiveCirclePacking } from "@nivo/circle-packing";
import { useMemo } from "react";

export const BubbleChart = ({ data, height }) => {
  const isLightColor = (color) => {
    const hex = color.replace("#", "");
    const c_r = Number.parseInt(hex.substring(0, 0 + 2), 16);
    const c_g = Number.parseInt(hex.substring(2, 2 + 2), 16);
    const c_b = Number.parseInt(hex.substring(4, 4 + 2), 16);
    const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;
    return brightness > 155;
  };

  const CustomTooltip = ({ node }) => {
    return (
      <div
        style={{
          background: "#2B2B2B",
          padding: "8px 8px",
          borderRadius: "8px",
          color: "#fff",
          fontSize: 10,
          maxWidth: "200px",
        }}
      >
        <strong>{node.id}</strong>
      </div>
    );
  };

  return (
    <div style={{ height }}>
      <ResponsiveCirclePacking
        data={data}
        id="name"
        value="value"
        colors={(node) => node.data.color}
        padding={5}
        animate={true}
        motionConfig="gentle"
        enableLabels={true}
        labelsSkipRadius={60}
        labelTextColor={(node) => (isLightColor(node.color) ? "#000" : "#fff")}
        tooltip={(node) => <CustomTooltip node={node} />}
        theme={{
          labels: {
            text: {
              fill: "#ffffff",
              fontSize: 10,
            },
          },
        }}
        leavesOnly={true}
      />
    </div>
  );
};
